import Constant from '@/const';
import axios from 'axios';

const getAllDocumentsByIdEmr = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/patient/document/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getAllDocumentsByIdEmr;
